 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"default~landing-landing-module~main-admin-admin-module~main-medic-history-history-module~main-patien~83d21d7c":"default~landing-landing-module~main-admin-admin-module~main-medic-history-history-module~main-patien~83d21d7c","default~landing-landing-module~main-admin-admin-module~main-patient-patient-module~main-portal-porta~2415b4f4":"default~landing-landing-module~main-admin-admin-module~main-patient-patient-module~main-portal-porta~2415b4f4","default~main-admin-admin-module~main-medic-history-history-module~main-patient-patient-module~main-p~66d2bdca":"default~main-admin-admin-module~main-medic-history-history-module~main-patient-patient-module~main-p~66d2bdca","default~main-admin-admin-module~main-patient-patient-module~main-portal-portal-module~main-sales-sal~cfea3bd3":"default~main-admin-admin-module~main-patient-patient-module~main-portal-portal-module~main-sales-sal~cfea3bd3","default~landing-landing-module~main-admin-admin-module~main-medic-history-history-module~main-patien~8c5823f6":"default~landing-landing-module~main-admin-admin-module~main-medic-history-history-module~main-patien~8c5823f6","default~main-admin-admin-module~main-medic-history-history-module~main-patient-patient-module~main-p~578cdd08":"default~main-admin-admin-module~main-medic-history-history-module~main-patient-patient-module~main-p~578cdd08","default~main-admin-admin-module~main-auth-auth-module~main-medic-history-history-module~main-patient~4b86bbf2":"default~main-admin-admin-module~main-auth-auth-module~main-medic-history-history-module~main-patient~4b86bbf2","default~main-admin-admin-module~main-medic-history-history-module~main-patient-patient-module~main-p~5543bd1c":"default~main-admin-admin-module~main-medic-history-history-module~main-patient-patient-module~main-p~5543bd1c","default~landing-landing-module~main-admin-admin-module~main-patient-patient-module~main-portal-porta~244d2500":"default~landing-landing-module~main-admin-admin-module~main-patient-patient-module~main-portal-porta~244d2500","default~main-admin-admin-module~main-patient-patient-module~main-portal-portal-module~main-secretary~71addfe0":"default~main-admin-admin-module~main-patient-patient-module~main-portal-portal-module~main-secretary~71addfe0","default~main-portal-portal-module~main-secretary-secretary-module":"default~main-portal-portal-module~main-secretary-secretary-module","main-portal-portal-module":"main-portal-portal-module","main-secretary-secretary-module":"main-secretary-secretary-module","main-admin-admin-module":"main-admin-admin-module","main-patient-patient-module":"main-patient-patient-module","default~main-telemedicine-telemedicine-module~telemedicine-telemedicine-module":"default~main-telemedicine-telemedicine-module~telemedicine-telemedicine-module","main-auth-auth-module":"main-auth-auth-module","main-busqueda-busqueda-module":"main-busqueda-busqueda-module","landing-landing-module":"landing-landing-module","login-2-login-2-module":"login-2-login-2-module","register-register-module":"register-register-module"}[chunkId]||chunkId) + "-es2015." + {"default~landing-landing-module~main-admin-admin-module~main-medic-history-history-module~main-patien~83d21d7c":"45eaa7748ce87516690d","default~landing-landing-module~main-admin-admin-module~main-patient-patient-module~main-portal-porta~2415b4f4":"4c1b56c991a35bd4eff2","default~main-admin-admin-module~main-medic-history-history-module~main-patient-patient-module~main-p~66d2bdca":"07c9bf070375275a21f3","default~main-admin-admin-module~main-patient-patient-module~main-portal-portal-module~main-sales-sal~cfea3bd3":"6d221ecbbc6c25c07c7d","default~landing-landing-module~main-admin-admin-module~main-medic-history-history-module~main-patien~8c5823f6":"1fbc242fe026849d090a","default~main-admin-admin-module~main-medic-history-history-module~main-patient-patient-module~main-p~578cdd08":"bd5b71cfb35abfa56122","default~main-admin-admin-module~main-auth-auth-module~main-medic-history-history-module~main-patient~4b86bbf2":"2ddd483e6e5332ee8ecb","default~main-admin-admin-module~main-medic-history-history-module~main-patient-patient-module~main-p~5543bd1c":"a57dcf5f06ae87441f7c","default~landing-landing-module~main-admin-admin-module~main-patient-patient-module~main-portal-porta~244d2500":"f21e9fae6eb9ed0cc946","default~main-admin-admin-module~main-patient-patient-module~main-portal-portal-module~main-secretary~71addfe0":"969a16e6df3bf9d5449f","default~main-portal-portal-module~main-secretary-secretary-module":"9a0487cb1156403ccb94","main-portal-portal-module":"33e13abe2f0e67c0282e","main-secretary-secretary-module":"bf4fdcf358dea420cf75","main-admin-admin-module":"3dc6595f509d183e6012","main-patient-patient-module":"c9de48f1c17bc9cbf7e1","default~main-telemedicine-telemedicine-module~telemedicine-telemedicine-module":"27f57e79aefb0decc890","main-auth-auth-module":"2c1aa0f0d4579d7e84dd","main-busqueda-busqueda-module":"ed1c595de0d20b1f9b5d","landing-landing-module":"1b0d5d7dfb0d4bab1240","login-2-login-2-module":"81ee879c08056c9f3729","register-register-module":"2d27a6a3ecb881800c66"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
